import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { useChatStore } from "../store/chat";
import lifeforce from "../backend/lifeforce";

type AuthContextType = {
  user: any | null;
};

const AuthContext = createContext<AuthContextType>({
  user: null,
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<any | null>(null);
  const [token, setToken] = useState<string | null>(null);

  const setStoreUser = useChatStore((s) => s.setUser);
  const setHistory = useChatStore((s) => s.setHistory);
  const receiveServerSideEvent = useChatStore((s) => s.receiveServerSideEvent);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setToken(session?.access_token ?? null);
      setStoreUser(session?.user ?? null);
      setUser(session?.user ?? null);
    });

    supabase.auth.onAuthStateChange((_event, session) => {
      setToken(session?.access_token ?? null);
      setStoreUser(session?.user ?? null);
      setUser(session?.user ?? null);
    });

  }, [])

  useEffect(() => {
    if (!token) {
      lifeforce.unregister();
    }

    if (token) {
      lifeforce.register(token, receiveServerSideEvent);
      lifeforce.history().then((history) => {
        if (history) {
          setHistory(history);
        }
      });
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
